import { render } from "./OrderAlert.vue?vue&type=template&id=f3d335f0"
import script from "./OrderAlert.vue?vue&type=script&lang=js"
export * from "./OrderAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__